import { useState, useEffect } from "react";
import { ciudadesAPI } from "../../api";
import toast from "react-hot-toast";

export default function Ciudades() {
  const [ciudades, setCiudades] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [nueva, setNueva] = useState("");
  const [guardando, setGuardando] = useState(false);

  const cargar = async () => {
    setCargando(true);
    try {
      const res = await ciudadesAPI.listar();
      setCiudades(res.data.data);
    } catch {
      toast.error("Error cargando ciudades");
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { cargar(); }, []);

  const handleAgregar = async (e) => {
    e.preventDefault();
    if (!nueva.trim()) return;
    setGuardando(true);
    try {
      const res = await ciudadesAPI.crear(nueva.trim());
      setCiudades((prev) => [...prev, res.data.data].sort((a, b) => a.nombre.localeCompare(b.nombre)));
      setNueva("");
      toast.success("Ciudad agregada");
    } catch (err) {
      toast.error(err.response?.data?.message || "Error agregando ciudad");
    } finally {
      setGuardando(false);
    }
  };

  const handleEliminar = async (id, nombre) => {
    if (!window.confirm(`¿Eliminar "${nombre}"?`)) return;
    try {
      await ciudadesAPI.eliminar(id);
      setCiudades((prev) => prev.filter((c) => c.id !== id));
      toast.success("Ciudad eliminada");
    } catch {
      toast.error("Error eliminando ciudad");
    }
  };

  return (
    <div className="fade-in" style={{ maxWidth: 560 }}>
      <div className="page-header">
        <div>
          <h1 className="heading-serif page-title">Ciudades</h1>
          <p style={{ color: "var(--color-text-muted)", fontSize: ".9rem" }}>
            Administra las ciudades disponibles al crear propiedades
          </p>
        </div>
      </div>

      {/* Formulario agregar */}
      <div className="card" style={{ padding: "1.25rem", marginBottom: "1.5rem" }}>
        <form onSubmit={handleAgregar} style={{ display: "flex", gap: ".75rem" }}>
          <input
            className="form-input"
            value={nueva}
            onChange={(e) => setNueva(e.target.value)}
            placeholder="Ej: Veracruz, Xalapa, Orizaba..."
            autoFocus
          />
          <button
            type="submit"
            className="btn btn-accent"
            disabled={guardando || !nueva.trim()}
            style={{ whiteSpace: "nowrap" }}
          >
            {guardando ? "..." : "+ Agregar"}
          </button>
        </form>
      </div>

      {/* Lista */}
      <div className="card">
        {cargando ? (
          <div className="spinner" style={{ margin: "2rem auto" }} />
        ) : ciudades.length === 0 ? (
          <div style={{ padding: "3rem", textAlign: "center", color: "var(--color-text-muted)" }}>
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>🏙️</div>
            <p>No hay ciudades. Agrega la primera arriba.</p>
          </div>
        ) : (
          <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
            {ciudades.map((ciudad, i) => (
              <li
                key={ciudad.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: ".85rem 1.25rem",
                  borderBottom: i < ciudades.length - 1 ? "1px solid var(--color-border)" : "none",
                }}
              >
                <span style={{ fontWeight: 500 }}>🏙️ {ciudad.nombre}</span>
                <button
                  className="btn btn-ghost btn-sm"
                  style={{ color: "var(--color-error)" }}
                  onClick={() => handleEliminar(ciudad.id, ciudad.nombre)}
                >
                  🗑️ Eliminar
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      <p style={{ marginTop: "1rem", fontSize: ".8rem", color: "var(--color-text-muted)" }}>
        {ciudades.length} ciudad{ciudades.length !== 1 ? "es" : ""} registrada{ciudades.length !== 1 ? "s" : ""}
      </p>
    </div>
  );
}
